export const light = {
  primary: "hsl(233, 41%, 8%)",
  secondary: "hsl(233,41%,28%)",
  accent: "hsl(212, 96%, 54%)",
  primaryText: "rgba(0, 0, 0, 0.87)",
  secondaryText: "rgba(0, 0, 0, 0.54)",
  white: "#FFFFFF",
  black: "#000000",
};

export const dark = {};
